import React, { useEffect, useState } from "react";
import styles from "../../../../styles/scope3/Dashboard/purchaseGoods.module.css";
import { get } from "../../../../utils/api";

const Dashboard = () => {
  const [cardData, setCardData] = useState({
    totalEntries: 0,
    totalUnitsSold: 0,
    totalDocumentsUploaded: 0,
  });

  const fetchCardData = async () => {
    try {
      const res = await get("/scope3/useOfSoldProducts/cardData");
      const data = res?.data?.data || {};

      setCardData({
        totalEntries: Number(data?.totalEntries || 0),
        totalUnitsSold: Number(data?.totalUnitsSold || 0),
        totalDocumentsUploaded: Number(data?.totalDocumentsUploaded || 0),
      });
    } catch (error) {
      console.log("error", error);
    }
  };

  useEffect(() => {
    fetchCardData();
  }, []);

  return (
    <div className={styles.purchase_container}>
      <div className={styles.heading_container}>
        <p className={styles.heading}>Use of Sold Products</p>
      </div>

      <p className={styles.sub_heading}>Overview</p>

      <div className={styles.emission_container}>
        <div className={styles.card_container}>
          <p className={styles.graph_heading}>Total Entries</p>
          <p className={styles.card_value}>{cardData.totalEntries}</p>
        </div>

        <div className={styles.card_container}>
          <p className={styles.graph_heading}>Total Units Sold</p>
          <p className={styles.card_value}>{cardData.totalUnitsSold}</p>
        </div>

        <div className={styles.card_container}>
          <p className={styles.graph_heading}>Total Documents Uploaded</p>
          <p className={styles.card_value}>{cardData.totalDocumentsUploaded}</p>
        </div>
      </div>
    </div>
  );
};

export default Dashboard;
